import { Briefcase, CheckSquare, LayoutTemplate } from "lucide-react";
import { HeaderSplitNav, type HeaderSplitNavEntry } from "./HeaderSplitNav";

const PROJECTS_ROUTES = ["/tasks", "/templates"];

export function ProjectsNav() {
  const entries: HeaderSplitNavEntry[] = [
    { label: "Projects", href: "/", icon: Briefcase },
    { label: "Tasks", href: "/tasks", icon: CheckSquare },
    { label: "Templates", href: "/templates", icon: LayoutTemplate },
  ];

  return (
    <HeaderSplitNav
      label="Projects"
      icon={Briefcase}
      href="/"
      entries={entries}
      activeRoutes={["/", ...PROJECTS_ROUTES]}
      testId="projects"
    />
  );
}
